import React from "react";
import { TestInfo } from "./TestInfo";
import { PracticeInfo } from "./PracticeInfo";
import { InsuranceInfo } from "./InsuranceInfo";
import { SeerezOtherInfo } from "./SeerezOtherInfo";
import { PharmacyPracticeInfo } from "./PharmacyPracticeInfo";
import { OtherInfo } from "./OtherInfo";

export const SeerezCaseDetails = ({
  test,
  practice,
  primaryInsuranceInfo,
  paOtherInfo,
  isPharmacyOwnedByClinic,
  pharmacyPracticeInfo,
  pharmacyOtherInfo,
}) => {
  return (
    <>
      <h4 className="text-secondary h3 fw-medium mt-4">Prior Auth Details</h4>

      <div className="vstack gap-3">
        {!isPharmacyOwnedByClinic && <TestInfo testInfo={test} />}
        {!isPharmacyOwnedByClinic && <PracticeInfo practiceInfo={practice} />}
        {isPharmacyOwnedByClinic && <PharmacyPracticeInfo pharmacyPracticeInfo={pharmacyPracticeInfo} />}
        <InsuranceInfo insuranceInfo={primaryInsuranceInfo} />
        {!isPharmacyOwnedByClinic && <SeerezOtherInfo seerezOtherInfo={paOtherInfo} />}
        {isPharmacyOwnedByClinic && <OtherInfo otherInfo={pharmacyOtherInfo} />}
      </div>
    </>
  );
};
